<div [ngClass]="{ 'has-error': hasQuantityError$ | async }" class="quantity-input">
  @switch (type()) { @case ("select") {
  <select (change)="change($event.target)" class="form-control" [id]="id()" data-testing-id="quantity">
    @for (opt of selectValues$ | async; track opt) {
    <option [value]="opt" [selected]="opt === (quantity$ | async)">
      {{ opt }}
    </option>
    }
  </select>
  } @case ('input') {
  <input
    class="form-control"
    [id]="id()"
    data-testing-id="quantity"
    type="number"
    pattern="[0-9]*"
    [value]="quantity$ | async"
    [min]="min$ | async"
    [max]="max$ | async"
    [step]="step$ | async"
    (change)="change($event.target)"
    (keyup)="change($event.target)"
    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
  />
  } @default {
  <div class="counter-input">
    <button
      type="button"
      class="btn btn-link decrease-button"
      (click)="decrease()"
      [disabled]="cannotDecrease$ | async"
      [attr.data-testing-id]="'decrease-quantity-' + id()"
      translate
      tabindex="-1"
    >
      product.quantity.decrease.text
    </button>
    <button
      type="button"
      class="btn btn-link increase-button"
      (click)="increase()"
      [disabled]="(cannotIncrease$ | async) || !(product$ | async)?.available || (isButtonDisable$() | async)"
      [attr.data-testing-id]="'increase-quantity-' + id()"
      translate
      tabindex="-1"
    >
      product.quantity.increase.text
    </button>
    <input
      #quantityInput
      class="form-control text-center"
      [id]="id()"
      data-testing-id="quantity"
      type="number"
      pattern="[0-9]*"
      [disabled]="(product$ | async)?.failed || (isButtonDisable$() | async)"
      [value]="quantity$ | async"
      [min]="min$ | async"
      [max]="max$ | async"
      [step]="step$ | async"
      (change)="change($event.target); this.quantityChange.next($event.target)"
      (keyup)="change($event.target)"
      (keydown.enter)="$event.preventDefault(); changeOnEnter()"
      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
    />
  </div>
  } } @if (hasQuantityError$ | async) {
  <small class="validation-message qty-validation-message">{{ quantityError$ | async }}</small>
  }
</div>
